// Reviews.jsx
import { useEffect, useState } from "react";
import { deleteReview, getAllReviews } from "../../services/reviewService";


export default function Reviews() {
    const [reviews, setReviews] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        getAllReviews().then(data => {
            setReviews(data);
            setLoading(false);
        }).catch(err => {
            console.error("Failed to fetch reviews:", err);
        });
    }, []);

    const handleDelete = (reviewId) => {
        const conf = window.confirm("Are you sure you want to delete this review?");
        if (!conf) {
            return;
        }
        setLoading(true)
        deleteReview(reviewId).then((res) => {
            if (res.status === "success"){
                setReviews(reviews.filter(review => review.id !== reviewId));
                alert("review deleted successfully!");
            }
            else {
                alert(res.message)
            }
        }).catch(err => {
            console.error("Failed to delete review:", err);
        }).finally (() => {
            setLoading(false)
        });
    };


    return (
        <section className="trips">
            <header className="trips-header">
                <h1>Reviews</h1>
                {/* <Link to="/admin/reviews/new" className="btn-primary">+ New Review</Link> */}
            </header>


            <div className="trip-grid">
                {!loading && reviews.length === 0 && <p>No reviews found.</p>}
                {reviews && reviews.map((review, i) => (
                    <article className="trip-card" key={i}>
                        <div className="trip-card-top">
                            <h3>{review.name}</h3>
                        </div>
                        <p className="meta"> {review.trip.title}</p>
                        <p className="meta">Stars: {review.stars}</p>
                        <p className="meta">Message: {review.message}</p>
                        <p className="meta">Date: {review.date}</p>

                        <div className="flex row gap-10">
                            
                            <button onClick={() => handleDelete(review._id)} className="btn-danger">Delete</button>
                        </div>
                    </article>
                ))}
            </div>
        </section>
    );
}